export const meta = {
  slug: { de: "online-terminbuchung-wann-sinnvoll", en: "online-booking-when-it-makes-sense" },
  title: "Online-Terminbuchung: wann sie wirklich entlastet und wann nicht",
  excerpt:
    "Eine Online-Buchung hilft nur dann, wenn sie zur Realität der Praxis passt. Worauf es bei Terminarten, Regeln und Übersicht ankommt.",
  category: "einblicke",
  publishedAt: "2026-04-20",
  updatedAt: "2026-05-06",
  metaTitle: "Wann Online-Terminbuchung sinnvoll ist | OnePractix",
  metaDescription:
    "Wann eine Online-Terminbuchung den Praxisalltag wirklich entlastet – und wann sie zusätzlichen Aufwand erzeugt. Strukturierte Einblicke für Praxen.",
  related: ["telefon-besetzt-anrufe-im-praxisalltag", "praxiswebsite-struktur-statt-design"],
  en: {
    title: "Online appointment booking: when it really helps and when it doesn't",
    metaTitle: "When online booking helps practices | OnePractix",
    metaDescription:
      "When online appointment booking really relieves a practice — and when it adds extra work. Structured insights for medical practices.",
    excerpt:
      "Online booking only helps when it fits the reality of the practice. What matters in appointment types, rules and a calm overview.",
  },
};

export default meta;
